export const setLevelImage = (filter: any) => ({
    type: 'SET_LEVEL_IMAGE',
    payload: filter,
  });
  